export { default } from './MyFullCalendar.component';
